export const STATUSES_ARCHIVED = [
  'ORDER_COMPLETED',
  'ORDER_CANCELLED',
  'NON_TARGET_ORDER',
];

export const ORDER_TYPE = {
  supplier: 'Supplier',
  retail: 'Incoming',
  dealers: 'Dealers',
};

export const ORDER_RETAIL_TAB = {
  product: {
    path: 'products',
    title: 'Входящие заказы',
  },
  segment: {
    path: 'segments',
    title: 'Переданные партнеру',
  },
};

export const NEW_ORDER_TAB = {
  zgi: {
    path: 'zgi',
    title: 'Заказ готовых изделий',
  },
  cut: {
    path: 'cut',
    title: 'Заказ отрезов',
  },
  opt: {
    path: 'opt',
    title: 'Заказ оптовых позиций',
  },
};

// действия с заказом
export const ORDER_ACTION = {
  //сформировать заказ
  create: 'create',
  //отправить заказ
  send: 'send',
  //вернуть заказ
  return: 'return',
};

export const UNIT = {
  millimeters: 1,
  centimeters: 2,
  meters: 3,
}

